import React, { useCallback, useEffect, useState } from "react";
import copy from "copy-to-clipboard";
import { Alert, message, Popover } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import {
  formatBalance,
  formatDecimal,
  formatDecimalWithSeparation,
  safeParseUnits,
} from "celer-web-utils/lib/format";
import {
  useAccount,
  useChainId,
  useSwitchChain,
  useWriteContract,
} from "wagmi";
import styles from "./index.module.scss";
import { useModalStore } from "@/store/modle";
import moreUp from "@/assets/images/moreUp.svg";
import moreDown from "@/assets/images/moreDown.svg";
import close from "@/assets/images/close.svg";
import error from "@/assets/images/error.svg";
import lightInfo from "@/assets/images/lightInfo.svg";
import brevIcon from "@/assets/images/BREV.png";

import { MoreDetailsContent } from "../dashboard";
import { Contract, JsonRpcProvider, MaxUint256 } from "ethers";
import { AddressZero, erc20Abi, stakingABI, validFloatRegex } from "./ABI";
import { contract_address, getChainInfoById } from "@/constants/const";
import { useDataStore, WalletSource } from "@/store/dataStore";
import ChainSwitchModal from "./ChainSwitchModal";
import { useTransactionError } from "@/hooks/useTransactionError";
import { useNavigate } from "react-router-dom";

export enum StakingStatus {
  stakeInit,
  staking,
  stakingSuccess,
}

export const targetChainId = process.env.REACT_APP_PUBLIC_CLAIM_CHAIN
  ? Number(process.env.REACT_APP_PUBLIC_CLAIM_CHAIN)
  : 8453;
export const stakingAddress = contract_address.staking_controller as any;
export const tokenDecimals = Number(localStorage.getItem("decimals")) || 18;

export const tokenSymbol = localStorage.getItem("symbol") || "BREV";
export const tokenAddress =
  localStorage.getItem("tokenAddress") ||
  "0x086F405146Ce90135750Bbec9A063a8B20A8bfFb";
let timer: any;
let timeouter: any;
const StakeModal: React.FC = () => {
  const setDashboardReload = useModalStore((state) => state.setDashboardReload);
  const setShowStakeModal = useModalStore((state) => state.setShowStakeModal);
  const showStakeModal = useModalStore((state) => state.showStakeModal);
  const setShowChainSwitchWarningModal = useModalStore(
    (state) => state.setShowChainSwitchWarningModal
  );
  const showChainSwitchWarningModal = useModalStore(
    (state) => state.showChainSwitchWarningModal
  );
  const isMobile = useDataStore((state) => state.isMobile);
  const { selectedStake, setRefreshData } = useDataStore((state) => state);
  const [detailsShow, setDetailsShow] = useState(false);
  const [stakeAmount, setStakeAmount] = useState("");
  const [maxShowStakeAmount, setMaxShowStakeAmount] = useState("");
  const [stakeDisabled, setStakeDisabled] = useState(true);
  const [showError, setShowError] = useState("");
  const [stakeError, setStakeError] = useState(false);
  // const [isApproved, setIsApproved] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const [stakeLoading, setStakeLoading] = useState(false);
  const [balance, setBalance] = useState("");
  const [needApprove, setNeedApprove] = useState(false);
  const [approveDone, setApproveDone] = useState(false);
  const [switchLoading, setSwitchLoading] = useState(false);
  const [stakeStatus, setStakeStatus] = useState<StakingStatus>(
    StakingStatus.stakeInit
  );
  const [allowance, setAllowance] = useState("");
  const { walletSource, tokenPrice } = useDataStore((state) => state);
  const [txHash, setTxHash] = useState("");
  const [chainId, setChainId] = useState(1);
  const [shouldSwitchChain, setShouldSwitchChain] = useState(false);
  // const [showSwitchModal, setShowSwitchModal] = useState(false);

  // const txError = useModalStore((state) => state.txError);
  // const setTxError = useModalStore((state) => state.setTxError);
  const { address, connector } = useAccount();
  const { writeContractAsync } = useWriteContract();
  const { switchChainAsync } = useSwitchChain();
  const navigate = useNavigate();

  const id = useChainId();

  useTransactionError(stakeError, isMobile);

  useEffect(() => {
    setShowChainSwitchWarningModal(false);
    setMaxShowStakeAmount("");
  }, []);
  const getChainId = async () => {
    if (typeof window.ethereum !== "undefined") {
      try {
        const chainId = await window.ethereum.request({
          method: "eth_chainId",
        });
        console.log("ID:", chainId, parseInt(chainId));
        return parseInt(chainId);
      } catch (error) {
        console.error("get chainId error:", error);
      }
    } else {
      console.error("MetaMask none");
    }
  };

  useEffect(() => {
    if (
      walletSource === WalletSource.FromWeb &&
      connector?.name !== "Coinbase Wallet"
    ) {
      if (chainId === targetChainId) {
        setShouldSwitchChain(false);
        setShowChainSwitchWarningModal(false);
      } else {
        setShouldSwitchChain(true);
      }
    } else {
      if (id === targetChainId) {
        setShouldSwitchChain(false);
        setShowChainSwitchWarningModal(false);
      } else {
        setShouldSwitchChain(true);
      }
    }
  }, [id, chainId, walletSource, targetChainId]);

  useEffect(() => {
    if (!connector) {
      return;
    }
    if (
      connector?.name === "WalletConnect" ||
      connector?.name === "Coinbase Wallet"
    ) {
      setChainId(id);
    } else {
      if (typeof window.ethereum !== "undefined") {
        const fetchChainId = async () => {
          try {
            const targetChainId = await window.ethereum.request({
              method: "eth_chainId",
            });
            setChainId(parseInt(targetChainId));
            console.log("chainId22:", parseInt(targetChainId));
          } catch (error) {
            console.error("get chainId error:", error);
          }
        };
        fetchChainId();
        const handleChainChanged = (newChainId: any) => {
          setChainId(parseInt(newChainId));
        };
        window.ethereum.on("chainChanged", handleChainChanged);
        return () => {
          window.ethereum.removeListener("chainChanged", handleChainChanged);
        };
      } else {
        console.error("MetaMask error");
      }
    }
  }, [connector, id]);

  const getTokenBalance = async () => {
    if (!address) {
      return;
    }
    const provider = new JsonRpcProvider(
      getChainInfoById(targetChainId).rpcUrl
    );
    const tokenContract = new Contract(tokenAddress, erc20Abi, provider);
    const res = await tokenContract.balanceOf(address);
    // const balance = safeParseUnits(res?.toString() || "0", tokenDecimals || 18);
    setBalance(res.toString());
  };

  useEffect(() => {
    if (!address) {
      return;
    }
    getTokenBalance();
  }, [address]);

  const getAllowance = useCallback(() => {
    if (!stakingAddress || !address) {
      return;
    }
    const provider = new JsonRpcProvider(
      getChainInfoById(targetChainId).rpcUrl
    );
    const tokenContract = new Contract(tokenAddress, erc20Abi, provider);
    // const stakingContract = new Contract(stakingAddress, stakingABI, provider);
    // stakingContract
    //   ?.getProverState(selectedStake?.proverAddress)
    //   .then((result) => {
    //     console.log("getProverState res:", result);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
    tokenContract
      ?.allowance(address, stakingAddress || AddressZero)
      .then((result) => {
        setAllowance(result);
        // setApproveLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [address, stakingAddress, tokenAddress, targetChainId, AddressZero]);

  // useEffect(() => {
  //   if (!validFloatRegex.test(stakeAmount)) {
  //     return;
  //   }
  //   if (stakeAmount.length > 0) {
  //     const value =
  //       safeParseUnits(Number(stakeAmount).toString(), tokenDecimals || 18) ||
  //       BigInt(0);
  //     if (
  //       BigInt(value.toString()) > BigInt(allowance) ||
  //       BigInt(allowance) === BigInt(0)
  //     ) {
  //       setNeedApprove(true);
  //       setApproveDone(false);
  //     } else {
  //       setNeedApprove(false);
  //       setApproveDone(true);
  //     }
  //   } else {
  //     setNeedApprove(false);
  //     setApproveDone(true);
  //   }
  // }, [stakeAmount, allowance]);

  useEffect(() => {
    getAllowance();
  }, [getAllowance]);

  const copyText = (address: string) => {
    copy(address || "");
    message.success("copy success !");
  };

  const handleInputChange = (value: string, isFromMax = false) => {
    if (isFromMax) {
      setMaxShowStakeAmount(
        formatDecimal(balance, 6, tokenDecimals, "floor", true)
      );
      setStakeAmount(value);
      setStakeDisabled(false);
      setShowError("");
      const val =
        safeParseUnits(Number(value).toString(), tokenDecimals || 18) ||
        BigInt(0);
      if (
        BigInt(val.toString()) > BigInt(allowance) ||
        BigInt(allowance) === BigInt(0)
      ) {
        setNeedApprove(true);
        setApproveDone(false);
      } else {
        setNeedApprove(false);
        setApproveDone(true);
      }
      return;
    }
    setMaxShowStakeAmount("");
    if (value === "" || Number(value) === 0) {
      setStakeAmount(value);
      setStakeDisabled(true);
      setShowError("");
      return;
    }
    const regex = /^\d*\.?\d*$/;
    if (regex.test(value)) {
      setStakeAmount(value);
      if (value !== "" && Number(value) < 1) {
        setStakeDisabled(true);
        setShowError(`Please input an amount larger than 1 ${tokenSymbol}.`);
        return;
      }
      const val =
        safeParseUnits(value.toString(), tokenDecimals || 18) || BigInt(0);
      if (
        BigInt(val.toString()) > BigInt(allowance) ||
        BigInt(allowance) === BigInt(0)
      ) {
        setNeedApprove(true);
        setApproveDone(false);
      } else {
        setNeedApprove(false);
        setApproveDone(true);
      }

      if (value !== "" && BigInt(val.toString()) > BigInt(balance)) {
        setStakeDisabled(true);
        setShowError(`Insufficient ${tokenSymbol} balance in your wallet.`);
      } else {
        setStakeDisabled(false);
        setShowError("");
      }
    }
  };

  const stake = async () => {
    if (shouldSwitchChain) {
      setShowChainSwitchWarningModal(true);
      return;
    }
    setStakeLoading(true);
    setStakeError(false);
    if (stakeLoading) {
      return;
    }
    if (!address) {
      setStakeLoading(false);
      return;
    }
    try {
      const value =
        safeParseUnits(Number(stakeAmount).toString(), tokenDecimals || 18) ||
        BigInt(0);
      const res = await writeContractAsync({
        address: stakingAddress,
        abi: stakingABI,
        functionName: "stake",
        args: [selectedStake?.proverAddress, value],
      });
      getHash(res);
      setStakeStatus(StakingStatus.staking);
    } catch (error) {
      console.log("claim error", error);
      setStakeLoading(false);
      if (
        JSON.stringify(error?.toString()).indexOf("User denied transaction") ===
          -1 &&
        JSON.stringify(error?.toString()).indexOf(
          "User rejected the request"
        ) === -1
      ) {
        setStakeError(true);
        setStakeStatus(StakingStatus.stakeInit);
      }
    }
  };

  const checkStatus = async (id: number, tx: string) => {
    const provider = new JsonRpcProvider(getChainInfoById(id).rpcUrl);
    const txReceipt = await provider.getTransactionReceipt(tx);
    if (txReceipt && txReceipt.status === 1) {
      clearTimeout(timeouter);
      clearInterval(timer);
      setStakeStatus(StakingStatus.stakingSuccess);
      setStakeLoading(false);
    }
  };

  const getTransactionStatus = async (safeTxHash: string) => {
    const response = await fetch(
      `https://safe-client.safe.global/v1/chains/${targetChainId}/multisig-transactions/${safeTxHash}/raw`
    );
    const data = await response.json();

    if (data.transactionHash) {
      //data.confirmations?.length === data.confirmationsRequired
      setTxHash(data.transactionHash);
      setStakeStatus(StakingStatus.staking);
      if (data.isExecuted) {
        clearTimeout(timeouter);
        clearInterval(timer);
        setStakeStatus(StakingStatus.stakingSuccess);
        setStakeLoading(false);
      }
    }
    return data.txStatus;
  };

  const getHash = async (txhash: string) => {
    if (!address || !connector) {
      return;
    }
    if (connector.name === "WalletConnect") {
      const res = await connector?.getProvider();
      const connectorInfo = res as any;

      const isSafe =
        connectorInfo?.session?.peer?.metadata?.name.indexOf("Safe") > -1;
      if (isSafe) {
        clearInterval(timer);
        timer = setInterval(() => {
          getTransactionStatus(txhash);
        }, 2000);
        clearTimeout(timeouter);
        timeouter = setTimeout(() => {
          clearInterval(timer);
          setStakeError(true);
          setStakeStatus(StakingStatus.stakeInit);
          setStakeLoading(false);
        }, 5 * 60 * 1000);
        return;
      }
    }
    setTxHash(txhash);
    setStakeStatus(StakingStatus.staking);
    clearInterval(timer);
    timer = setInterval(() => {
      checkStatus(targetChainId || 1, txhash);
    }, 2000);
    clearTimeout(timeouter);
    timeouter = setTimeout(() => {
      clearInterval(timer);
      setStakeError(true);
      setStakeStatus(StakingStatus.stakeInit);
      setStakeLoading(false);
    }, 1 * 60 * 1000);
  };
  const approveMethod = async () => {
    setApproveLoading(true);
    if (shouldSwitchChain) {
      setShowChainSwitchWarningModal(true);
      setApproveLoading(false);
      return;
    }
    if (!stakingAddress) {
      setApproveLoading(false);
      return;
    }
    setStakeError(false);
    try {
      // const approveTx = await tokenContract.approve(stakingAddress, MaxUint256);
      const value =
        safeParseUnits(Number(stakeAmount).toString(), tokenDecimals || 18) ||
        BigInt(0);
      const res = await writeContractAsync({
        address: tokenAddress as any,
        abi: erc20Abi,
        functionName: "approve",
        args: [stakingAddress, BigInt(value.toString())],
      });
      // await res.wait();
      // await getAllowance();

      const provider = new JsonRpcProvider(
        getChainInfoById(targetChainId).rpcUrl
      );
      const tokenContract = new Contract(tokenAddress, erc20Abi, provider);
      tokenContract
        ?.allowance(address, stakingAddress || AddressZero)
        .then((result) => {
          setAllowance(result);
          setApproveLoading(false);
          setApproveDone(true);
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (error) {
      console.log("approve error:", error);
      setApproveLoading(false);
      setApproveDone(false);
      console.log(
        `🚀 ~ approveMethod ~  ${JSON.stringify(
          error?.toString()
        )}.indexOf("User denied transaction"):`,
        JSON.stringify(error?.toString()).indexOf("User denied transaction")
      );
      if (
        JSON.stringify(error?.toString()).indexOf("User denied transaction") ===
          -1 &&
        JSON.stringify(error?.toString()).indexOf(
          "User rejected the request"
        ) === -1
      ) {
        setStakeError(true);
        setStakeStatus(StakingStatus.stakeInit);
      }
    }
  };

  const switchChain = async () => {
    setSwitchLoading(true);
    try {
      const res = await switchChainAsync({
        chainId: targetChainId,
      });
      let chanid = id;
      if (
        walletSource === WalletSource.FromWeb &&
        connector?.name !== "Coinbase Wallet"
      ) {
        chanid = (await getChainId()) || 1;
      }
      if (
        !(
          walletSource === WalletSource.FromWeb &&
          connector?.name === "Coinbase Wallet"
        )
      ) {
        setChainId(chanid);
      }

      console.log("🚀 ~ switchChain ~ chanid:", chanid);
      if (chanid === Number(targetChainId)) {
        setShouldSwitchChain(false);
        setShowChainSwitchWarningModal(false);
      }
      setSwitchLoading(false);
    } catch (error) {
      setSwitchLoading(false);
      console.log("switch error:", error);
    }
  };
  if (showChainSwitchWarningModal) {
    return (
      <ChainSwitchModal
        switchFunc={() => switchChain()}
        switchLoading={switchLoading}
      />
    );
  }

  let content = <div></div>;
  switch (stakeStatus) {
    case StakingStatus.stakeInit:
      content = (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className={styles.stakeTop}>
            <div className={styles.stakeTopLeft}>
              <img
                src={selectedStake?.proverIcon || "/prover.png"}
                alt=""
                style={{
                  width: isMobile ? "44px" : "48px",
                  height: isMobile ? "44px" : "48px",
                  marginRight: 6,
                  borderRadius: "100%",
                }}
              />
              <div className={styles.stakeTopText}>
                <div className={styles.stakeName}>
                  {selectedStake?.proverName}
                </div>{" "}
                <div className={styles.stakeAddr}>
                  {selectedStake?.proverAddress?.slice(0, 6) +
                    "..." +
                    selectedStake?.proverAddress?.slice(
                      selectedStake?.proverAddress.length - 4,
                      selectedStake?.proverAddress.length
                    )}
                  {/* 0x002C...de43 */}
                  <img
                    src={"/copy.svg"}
                    alt="copy"
                    onClick={() => copyText(selectedStake?.proverAddress || "")}
                    style={{ marginLeft: 4, cursor: "pointer" }}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.stakeDetails}
              onClick={() => setDetailsShow(!detailsShow)}
            >
              More Details{" "}
              <img src={detailsShow ? moreUp : moreDown} alt="moreDown" />
            </div>
          </div>
          {detailsShow && (
            <MoreDetailsContent
              styleName="overrideMoreDetails"
              data={selectedStake}
              tokenPrice={tokenPrice}
            />
          )}
          <div className={styles.stakeInputWrapper}>
            <div className={styles.stakeInputBox}>
              <div className={styles.stakeInputBoxLeft}>
                <div className={styles.stakeBrevIcon}>
                  {" "}
                  <img
                    src={brevIcon}
                    alt=""
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: "100%",
                    }}
                  />
                </div>
                <div className={styles.stakeBrevName}>{tokenSymbol}</div>
              </div>
              <input
                className={styles.stakeInput}
                placeholder="0.0"
                value={maxShowStakeAmount || stakeAmount}
                onChange={(e) => handleInputChange(e.target.value)}
              />
            </div>
            <div className={styles.stakeInputBottom}>
              <div className={styles.stakeInputBalance}>
                Balance:{" "}
                {formatDecimalWithSeparation(
                  balance?.toString(),
                  2,
                  tokenDecimals,
                  "floor",
                  ",",
                  true
                )}
              </div>
              <div
                className={styles.stakeInputMaxBtn}
                onClick={() => {
                  handleInputChange(
                    formatDecimal(
                      balance,
                      tokenDecimals,
                      tokenDecimals,
                      "floor",
                      true
                    ),
                    true
                  );
                }}
              >
                MAX
              </div>
            </div>
          </div>
          {showError && (
            <div className={styles.inputError}>
              <img src={error} alt="error" width={20} height={20} />
              {showError}
            </div>
          )}
          {/* For approved case */}
          {!needApprove ? (
            <div
              className={styles.commonBtn}
              data-disabled={stakeDisabled || stakeLoading}
              onClick={() => {
                if (needApprove || stakeDisabled || stakeLoading) {
                  return;
                }
                stake();
              }}
            >
              Stake {tokenSymbol}
              {stakeLoading && <LoadingOutlined style={{ marginLeft: 5 }} />}
            </div>
          ) : (
            <div className={styles.commonBtnWrap}>
              <div
                className={styles.commonSmallBtn}
                data-disabled={approveLoading || stakeDisabled || approveDone}
                onClick={() => {
                  if (!needApprove || stakeDisabled || approveLoading) {
                    return;
                  }
                  approveMethod();
                }}
              >
                Approve {tokenSymbol}
                {approveLoading ? (
                  <LoadingOutlined style={{ marginLeft: 5 }} />
                ) : (
                  <Popover
                    placement="top"
                    content={`You need to approve the Brevis staking contract to spend this amount of ${tokenSymbol} from your account.`}
                    rootClassName={styles.approvePopover}
                  >
                    <img src={lightInfo} alt="Brevis" width="16px" />
                  </Popover>
                )}
              </div>
              <div
                className={styles.commonSmallBtn}
                data-disabled={!approveDone || stakeDisabled || stakeLoading}
                onClick={() => {
                  if (!approveDone || stakeDisabled || stakeLoading) {
                    return;
                  }
                  stake();
                }}
              >
                Stake {tokenSymbol}
                {stakeLoading && <LoadingOutlined style={{ marginLeft: 5 }} />}
              </div>
            </div>
          )}
        </div>
      );
      break;
    case StakingStatus.staking:
      content = (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            className={styles.checkingMotion}
            style={{ marginTop: 12, marginBottom: 20 }}
          >
            <div className={styles.checkingMotionThumb}></div>
          </div>
          {isMobile ? (
            <div>
              <div className={styles.commonDes}>Confirming your stake</div>
              <div className={styles.commonDes2}>transaction on-chain…</div>
              <div className={styles.commonDes2}>Please wait.</div>
            </div>
          ) : (
            <div>
              <div className={styles.commonDes}>
                Confirming your stake transaction on-
              </div>
              <div className={styles.commonDes2}>chain…Please wait.</div>
            </div>
          )}
          <div
            className={styles.commonLink}
            onClick={() => {
              window.open(
                getChainInfoById(targetChainId).blockExplorerUrl +
                  "/tx/" +
                  txHash,
                "_blank"
              );
            }}
          >
            View in explorer
          </div>
        </div>
      );
      break;
    case StakingStatus.stakingSuccess:
      content = (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "-20px",
          }}
        >
          <img
            src={
              "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/stakeSuccess.svg"
            }
            alt="chainSwitchWarning"
            width={280}
            className={styles.commonImg}
          />
          <div className={styles.commonDes}>You have successfully staked</div>
          <div className={styles.commonDes2}>
            {formatBalance(stakeAmount, 2, "floor", ",", true)} {tokenSymbol}.
          </div>

          <div
            className={styles.commonLink}
            style={{
              marginTop: 20,
              fontSize: 14,
              fontFamily: "HKNova-Medium, sans-serif",
              fontWeight: 500,
            }}
            onClick={() => {
              window.open(
                getChainInfoById(targetChainId).blockExplorerUrl +
                  "/tx/" +
                  txHash,
                "_blank"
              );
            }}
          >
            View in explorer
          </div>
          <div
            className={styles.commonBtn}
            style={{ marginTop: 32 }}
            onClick={() => {
              setShowStakeModal(false);
              setDashboardReload(true);
              setRefreshData();
              navigate("/dashboard");
            }}
          >
            Done
          </div>
        </div>
      );
      break;
    default:
      break;
  }

  return (
    <div className={styles.stakeModalBox}>
      <Modal
        closable
        open={showStakeModal}
        width={460}
        // centered
        // style={{ top: "-40px" }}
        destroyOnHidden
        title={null}
        onCancel={() => {
          setShowStakeModal(false);
          setRefreshData();
        }}
        footer={null}
        maskClosable={false}
        className={`${styles.commonModal} `}
        closeIcon={<img src={close} alt="logo" width={24} height={24} />}
        modalRender={(node) => (
          <div>
            {stakeError && !isMobile && (
              <Alert
                message={"Transaction failed. Please try again."}
                type="error"
                style={{ marginBottom: 20 }}
                showIcon
              />
            )}
            {node}
          </div>
        )}
      >
        {content}
      </Modal>
    </div>
  );
};

export default StakeModal;
